import { SELECT_VEHICLEID } from '../types/formTypes'

function selectVehicleIdReducer( state = { selectVehicleId: '' }, action) {
    switch (action.type) {
        case SELECT_VEHICLEID:
            return {
                ...state,
                selectVehicleId: action.payload
            }
        default:
            return state;
    }
}

export { selectVehicleIdReducer }